import React from "react";
import { FaRegHandPointer } from "react-icons/fa";

export const PriKPI = ({
  Image,
  Alt,
  ColorDark,
  Title,
  Value,
  onclick,
  handPosition,
}) => {
  const content = (
    <div
      className={`grid w-full text-white rounded-lg ${ColorDark} mt-2 md:mt-0`}
    >
      <div className="grid relative w-full">
        {onclick && (
          <div
            className={`flex justify-center items-center absolute ${handPosition}`}
          >
            <button className="relative p-2 text-white bg-[#e03f3f] rounded-full hover:bg-blue-600 focus:outline-none group">
              <span className="text-base text-white">
                <FaRegHandPointer />
              </span>
              <span className="absolute inset-0 rounded-full bg-sky-400 opacity-75 blur-md animate-ping"></span>
            </button>
          </div>
        )}

        <div className="text-center px-3 font-semibold md:text-[14px] sm:text-[10px] whitespace-nowrap">
          {Title}
        </div>

        <div className="flex items-center w-full">
          <div className="w-[30%] flex justify-center">
            <img src={Image} alt={Alt} className="w-12 h-12" />
          </div>
          <div className="text-3xl w-[70%] text-center font-bold md:text-xl lg:text-3xl justify-self-center leading-5">
            {Value}
          </div>
        </div>
      </div>
    </div>
  );

  if (onclick) {
    return (
      <div
        onClick={onclick}
        className="w-full no-underline transition duration-300 ease-in-out transform hover:scale-105"
        title="Click here to View Detailed Summary"
      >
        {content}
      </div>
    );
  } else {
    return content;
  }
};
